import breadcrumbs from 'assets/img/breadcrumbs.svg';
import Text from 'components/Text/Text';
import { useCompareFormData } from 'hooks/useCompareFormData';
import {
	EditScheduleContext,
	IEditScheduleContext,
} from '../editScheduleModalContext/editScheduleModalState/editScheduleModalContext';
import React, { useContext } from 'react';
import { Form } from 'antd';
import Button from 'components/Button/Button';
import style from './BtnBlock.module.scss';

const BtnBlock: React.FC = () => {
	const { changeTypeOfModalWindow, initialFormData, schedule } =
		useContext<IEditScheduleContext>(EditScheduleContext);

	const currentFormData = {
		schedule,
	};

	const isEqualFormData = useCompareFormData(initialFormData, currentFormData);

	const handleCancel = () => {
		changeTypeOfModalWindow('toConfirmFieldsClearing');
	};

	return (
		<Form.Item>
			<div className={style.btnWrapper}>
				<Button
					className={style.cancelBtn}
					theme="outlined"
					onClick={handleCancel}
					icon={
						<svg className={style.icon}>
							<use xlinkHref={`${breadcrumbs}#resetIcon`} />
						</svg>
					}>
					<Text translationNameSpace="form" translationKey="cancelButton" asFragment={true} />
				</Button>
				<Button className={style.saveBtn} theme="primaryBlue" type="submit" disabled={isEqualFormData}>
					<Text translationNameSpace="form" translationKey="saveButton" asFragment={true} />
				</Button>
			</div>
		</Form.Item>
	);
};

export default BtnBlock;
